import { SuperAdminConstants } from '../../../_constants';

const initialState = { addCreditsLoading: true, data: '', error: false };

export function addCreditsReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ADD_CREDITS:
            return {
                addCreditsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ADD_CREDITS:
            return {
                addCreditsLoading: false,
                data: action.addCredits,
                error: false
            };
        case SuperAdminConstants.ADD_CREDITS_ERROR:
            return {
                addCreditsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageCredits/addCredits.reducer.js